// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--2BnAm","grid":"styles-module--grid--14V10"};